<template>
  <div class="aboutNX joinUs">
    <div class="banner" :style="`background-image:url(${banner.picUrl})`" @click="goBannerUrl" :class="{canClick: banner.connection}">
      <h1>一群人，一件事，一生一世，一起疯狂，一起浪漫</h1>
    </div>
    <div class="middle-content">
      <div class="j-left">
        <section>
          <h1>招聘部门</h1>
          <div v-for="(item,key) in recruitList" :key="key" class="j-btn" :class="{active:activeRecruit === key}" @click="changeClass(key)">{{item.recruitName}}</div>
        </section>
        <section>
          <h1>福利待遇</h1>
          <ul>
            <li v-for="(item,key) in welfareList" :key="key" class="welfare">
              <p class="title">{{item.title}} -</p>
              <p class="detail">{{item.content}}</p>
            </li>
          </ul>
        </section>
        <section class="concat">
          <h1>投递方式</h1>
          <p class="mb20"><i class="phone"></i>{{hrInfo.managerPhone}}</p>
          <p class="mb20"><i class="person"></i>人力资源经理-{{hrInfo.manager}}</p>
          <p class="mb20"><i class="email"></i>{{hrInfo.managerMail}}</p>

          <p class="tip">请将个人简历添加至邮件附件，邮件标题应为“<span class="blue">应聘岗位名称+姓名+手机号</span>”，发送至“<span class="blue">{{hrInfo.managerMail}}</span>”邮箱。</p>
        </section>
      </div>
      <div class="j-right">
        <ul class="j-list">
          <li v-for="(item,key) in jobList" :key="key" :class="{active:activeJob === key}" @click="changeJob(key)">
            {{item.positionName}}
            <div class="spe" v-if="key !== 0"></div>
          </li>
        </ul>
          <transition name="fade-transform" mode="out-in">
            <div class="j-detail" v-if="jobDetail.positionName">
              <div>
                <h1 class="blue">{{jobDetail.positionName}}</h1>
                <section>
                  <p><span>招聘单位：</span>{{jobDetail.company}}</p>
                  <p><span>工作地点：</span>{{jobDetail.jobAddress}}</p>
                  <p><span>工作经验：</span>{{jobDetail.experience}}</p>
                  <p><span>职业类别：</span>{{jobDetail.type}}</p>
                  <p><span>招聘人数：</span>{{jobDetail.number}}</p>
                  <p><span>专业要求：</span>{{jobDetail.major}}</p>
                  <p><span>发布时间：</span>{{jobDetail.releaseTime}}</p>
                  <p><span>学历要求：</span>{{jobDetail.education}}</p>
                  <p><span>性别要求：</span>{{jobDetail.gender}}</p>
                </section>

                <section>
                  <h2>【岗位职责】</h2>
                  <div class="desc" v-html="jobDetail.duty"></div>
                </section>

                <section>
                  <h2>【任职要求】</h2>
                  <div class="desc" v-html="jobDetail.requirement"></div>
                </section>
              </div>
            </div>
          </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { getSession, setSession } from '@/utils/index'
export default {
  name: 'joinUs',
  data () {
    return {
      banner: {
        picUrl: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg'
      },
      hrInfo: {},
      welfareList: [
        { title: '学', content: '新员工熔炼营、体系培训会议 (产品、技术、金融、市场) 、黄埔铁军培训' },
        { title: '医', content: '五险一金+商业保险（意外安全险）、年度体检' },
        { title: '食', content: '咖啡饮料、企业折扣专属福利、零食茶歇' },
        { title: '住', content: '专家公寓、公租房' },
        { title: '行', content: '打车报销、带薪年假' },
        { title: '乐', content: '节日福利、文体俱乐部、定期团建、专属生日礼物、定制纪念物' },
        { title: '奖', content: '金狮奖、金牛奖、金猪奖、达人奖、PM积分礼品奖' }
      ],
      activeRecruit: 1,
      recruitList: [],
      activeJob: 1,
      jobList: [],
      jobDetail: {}
    }
  },
  mounted () {
    if (!getSession('bannerPic')) {
      this.getBannerPage()
    } else {
      this.banner = getSession('bannerPic').join_us
    }

    this.getParameter()
    this.getRecruitPage()
    this.$scroll.reveal('.banner h1', {
      distance: '50px',
      origin: 'left',
      duration: 1000
    })
  },
  methods: {
    /**
     * 获取 banner 图片
     */
    async getBannerPage () {
      const params = {
        currentPage: 1,
        pageSize: 100
      }
      const res = await this.API.basic.getBannerPage(params) || []
      // eslint-disable-next-line prefer-const
      let arr = {}
      res.data.map(o => {
        this.$set(arr, o.remark, { picUrl: o.pictureUrl, connection: o.connection })
      })
      this.banner = arr.join_us
      setSession('bannerPic', arr)
    },
    /**
     * 获取参数设置（hr信息 / 联系方式 / 公众号）
     */
    async getParameter () {
      const res = await this.API.basic.getParameter() || []
      this.hrInfo = res.data
      setSession('basicInfo', res.data)
    },
    /**
     * 招聘分组列表
     */
    async getRecruitPage () {
      this.recruitList = []
      // const params = {
      //   currentPage: 1,
      //   pageSize: 100
      // }
      const res = await this.API.recruit.getRecruitPage() || []
      res.data.map(o => {
        this.recruitList.push({
          recruitName: o.recruitName,
          recruitId: o.recruitId
        })
      })
      if (this.recruitList.length > 0) {
        this.activeRecruit = 0
        // 查询职位列表
        this.getPositionPage()
      } else {
        this.activeRecruit = -1
      }
    },
    /**
     * 职位列表
     */
    async getPositionPage () {
      this.jobList = []
      const params = {
        recruitName: this.recruitList[this.activeRecruit].recruitName,
        currentPage: 1,
        pageSize: 100,
        sortRule: 0
      }
      const res = await this.API.recruit.getPositionPage(params) || []
      res.data.map(o => {
        if (o.state === '0') {
          this.jobList.push({
            positionName: o.positionName,
            positionId: o.positionId
          })
        }
      })
      if (this.jobList.length > 0) {
        this.activeJob = 0
        // 查询职位详情
        this.getPositionById()
      } else {
        this.activeJob = -1
      }
    },
    async getPositionById () {
      this.jobDetail = {}
      const res = await this.API.recruit.getPositionById({ positionId: this.jobList[this.activeJob].positionId }) || []
      res.data.duty = res.data.duty.replace(/\n/g, '<br/>')
      res.data.requirement = res.data.requirement.replace(/\n/g, '<br/>')
      this.jobDetail = res.data
    },
    /** 改变分组 */
    changeClass (val) {
      this.activeRecruit = val
      this.jobDetail = {}
      this.getPositionPage()
    },
    /** 改变职位 */
    changeJob (val) {
      this.activeJob = val
      this.getPositionById()
    },
    /** 跳转banner配置连接 */
    goBannerUrl () {
      if (!this.banner.connection) {
        return ''
      }
      window.open(this.banner.connection)
    }
  }
}
</script>
